<template>
  <div>
    <el-button type="infor" size="small" @click="showDialog">
      显示字段配置
    </el-button>
    <!--波次号、波次类型、状态、操作 不需要配置-->
    <el-dialog :visible.sync="show" title="显示字段设置">
      <div v-if="`${page}` === '1'" class="_dialog_container_box">
        <el-checkbox
          v-model="form[page].user_id"
          class="_item"
          style="margin-left: 30px"
        >
          用户id
        </el-checkbox>
        <el-checkbox v-model="form[page].consignee" class="_item">
          收货人姓名
        </el-checkbox>
        <el-checkbox
          v-model="form[page].wave_picking_mobile_hide"
          class="_item"
        >
          收货人手机
        </el-checkbox>
        <el-checkbox v-model="form[page].address" class="_item">
          收货人地址
        </el-checkbox>
        <el-checkbox v-model="form[page].wave_picking_full_allot" class="_item">
          是否配齐
        </el-checkbox>
        <el-checkbox v-model="form[page].shipping_company" class="_item">
          快递公司
        </el-checkbox>
        <el-checkbox v-model="form[page].shipping_num" class="_item">
          快递单号
        </el-checkbox>
        <el-checkbox
          v-model="form[page].wave_picking_is_put_picking_list"
          class="_item"
          >是否放置配货单
        </el-checkbox>
        <el-checkbox
          v-model="form[page].wave_picking_is_generate_picking_task"
          class="_item"
          >是否生成拣货任务
        </el-checkbox>

        <el-checkbox v-model="form[page].custom_note" class="_item">
          用户备注
        </el-checkbox>
        <el-checkbox v-model="form[page].admin_note" class="_item">
          客服备注
        </el-checkbox>
        <el-checkbox v-model="form[page].ck_remark" class="_item">
          仓库备注
        </el-checkbox>
        <el-checkbox
          v-model="form[page].wave_picking_picking_type"
          class="_item"
        >
          拣货方式
        </el-checkbox>

        <el-checkbox v-model="form[page].wave_picking_num" class="_item">
          待发货商品数量
        </el-checkbox>
        <el-checkbox v-model="form[page].weight" class="_item">
          实际重量
        </el-checkbox>
        <el-checkbox
          v-model="form[page].wave_picking_print_status"
          class="_item"
        >
          面单状态
        </el-checkbox>
        <el-checkbox
          v-if="`${page}` === '1'"
          v-model="form[page].wave_picking_pay_way"
          class="_item"
        >
          支付方式
        </el-checkbox>

        <el-checkbox v-model="form[page].order_sn" class="_item">
          订单号
        </el-checkbox>
        <el-checkbox v-model="form[page].create_time" class="_item">
          波次生成时间
        </el-checkbox>
        <el-checkbox
          v-model="form[page].wave_picking_is_stop_shipping"
          class="_item"
        >
          是否拦截
        </el-checkbox>
        <el-checkbox v-model="form[page].update_time" class="_item">
          更新时间
        </el-checkbox>

        <el-checkbox v-model="form[page].sk_time" class="_item">
          最近物流时间
        </el-checkbox>
        <el-checkbox v-model="form[page].sk_content" class="_item">
          最近物流信息
        </el-checkbox>
        <el-checkbox v-model="form[page].shipping_kdniao_state" class="_item">
          物流状态
        </el-checkbox>
        <el-checkbox v-model="form[page].wave_picking_is_stock" class="_item">
          是否囤货
        </el-checkbox>
        <el-checkbox
          v-model="form[page].wave_picking_ext_same_day_shipping"
          class="_item"
        >
          是否即日发
        </el-checkbox>
        <el-checkbox v-model="form[page].is_delivery_formal" class="_item">
          是否催发
        </el-checkbox>
        <el-checkbox v-model="form[page].pre_weight" class="_item">
          计算重量
        </el-checkbox>
        <el-checkbox v-model="form[page].guarantee_value_formal" class="_item">
          是否保价
        </el-checkbox>
      </div>

      <!-- 售后波次 -->
      <div v-if="`${page}` === '2'" class="_dialog_container_box">
        <el-checkbox
          v-model="form[page].user_id"
          class="_item"
          style="margin-left: 30px"
          >用户id
        </el-checkbox>
        <el-checkbox v-model="form[page].consignee" class="_item">
          收货人姓名
        </el-checkbox>
        <el-checkbox v-model="form[page].wave_picking_full_allot" class="_item">
          是否配齐
        </el-checkbox>
        <el-checkbox
          v-model="form[page].wave_picking_mobile_hide"
          class="_item"
        >
          收货人手机
        </el-checkbox>
        <el-checkbox v-model="form[page].address" class="_item">
          收货人地址
        </el-checkbox>
        <el-checkbox v-model="form[page].shipping_company" class="_item">
          快递公司
        </el-checkbox>
        <el-checkbox
          v-model="form[page].wave_picking_is_put_picking_list"
          class="_item"
        >
          是否放置配货单
        </el-checkbox>
        <el-checkbox
          v-model="form[page].wave_picking_is_generate_picking_task"
          class="_item"
        >
          是否生成拣货任务
        </el-checkbox>
        <el-checkbox
          v-model="form[page].wave_picking_picking_type"
          class="_item"
        >
          拣货方式
        </el-checkbox>
        <el-checkbox v-model="form[page].shipping_num" class="_item">
          快递单号
        </el-checkbox>
        <el-checkbox v-model="form[page].wave_picking_num" class="_item">
          待发总件数
        </el-checkbox>
        <el-checkbox v-model="form[page].weight" class="_item">
          实际重量
        </el-checkbox>
        <el-checkbox
          v-model="form[page].wave_picking_print_status"
          class="_item"
        >
          面单状态
        </el-checkbox>
        <el-checkbox v-model="form[page].work_id" class="_item">
          工单id
        </el-checkbox>
        <el-checkbox v-model="form[page].problem_name" class="_item">
          原工单问题
        </el-checkbox>
        <el-checkbox v-model="form[page].problem_desc" class="_item">
          问题描述
        </el-checkbox>
        <el-checkbox v-model="form[page].service_desc" class="_item">
          客服备注
        </el-checkbox>
        <el-checkbox v-model="form[page].word_dbid_blp_note" class="_item">
          拆包备注
        </el-checkbox>
        <el-checkbox v-model="form[page].create_time" class="_item">
          波次时间
        </el-checkbox>
        <el-checkbox v-model="form[page].update_time" class="_item">
          更新时间
        </el-checkbox>
        <el-checkbox v-model="form[page].sk_time" class="_item">
          最近物流时间
        </el-checkbox>
        <el-checkbox v-model="form[page].sk_content" class="_item">
          最近物流信息
        </el-checkbox>
        <el-checkbox v-model="form[page].shipping_kdniao_state" class="_item">
          物流状态
        </el-checkbox>
        <el-checkbox v-model="form[page].guarantee_value_formal" class="_item">
          是否保价
        </el-checkbox>
      </div>

      <div slot="footer">
        <el-button type="primary" @click="toSave">确定</el-button>
        <el-button type="info" @click="show = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["page"], // {1:普通波次, 2:售后波次}
  data() {
    return {
      show: false,
      form: {
        1: {
          // 售前波次
          user_id: true,
          consignee: true,
          wave_picking_mobile_hide: true,
          address: true,
          wave_picking_full_allot: true,
          shipping_company: true,
          shipping_num: true,
          wave_picking_is_put_picking_list: true,
          custom_note: true,
          admin_note: true, // 普通波次的客服备注
          ck_remark: true,
          wave_picking_picking_type: true,
          wave_picking_num: true,
          weight: true,
          wave_picking_print_status: true,
          wave_picking_pay_way: true,
          order_sn: true,
          create_time: true,
          shipments_date: true,
          wave_picking_is_stop_shipping: true,
          update_time: true,
          sk_time: true,
          sk_content: true,
          shipping_kdniao_state: true,
          wave_picking_is_stock: true,
          wave_picking_is_generate_picking_task: true,
          wave_picking_ext_same_day_shipping: true,
          is_delivery_formal: true,
          pre_weight: true,
          guarantee_value_formal: true, // 是否保价
        },

        2: {
          // 售后波次
          user_id: true,
          consignee: true,
          wave_picking_full_allot: true,
          wave_picking_mobile_hide: true,
          address: true,
          shipping_company: true,
          wave_picking_is_put_picking_list: true,
          wave_picking_picking_type: true,
          shipping_num: true,
          wave_picking_num: true,
          weight: true,
          wave_picking_print_status: true,
          work_id: true,
          problem_name: true,
          problem_desc: true,
          service_desc: true,
          word_dbid_blp_note: true,
          create_time: true,
          update_time: true,
          sk_time: true,
          sk_content: true,
          shipping_kdniao_state: true,
          wave_picking_is_generate_picking_task: true,
          guarantee_value_formal: true, // 是否保价
        },
      },
    };
  },

  created() {
    this.$nextTick(() => {
      this.init();
    });
  },

  methods: {
    init() {
      this.fetchMyFields().then((rs) => {
        // 后台保存的是字符串 5555
        // eslint-disable-next-line no-restricted-syntax
        for (const k in this.form[this.page]) {
          // eslint-disable-next-line no-continue
          if (this.form[this.page][k] === undefined) continue;
          // eslint-disable-next-line no-param-reassign
          rs[k] = rs[k] !== "false";
          this.$set(this.form[this.page], k, rs[k]);
        }
        this.success();
      });
    },

    showDialog() {
      this.show = true;
    },

    // 发送给父组件
    success() {
      this.$emit("onsuccess", JSON.parse(JSON.stringify(this.form[this.page])));
    },

    toSave() {
      this.save().then(() => {
        this.success();
        this.show = false;
      });
    },

    // 存储
    save() {
      const param = {
        table_code: this.getTableCode(),
        show_fields: this.form[this.page],
      };
      return new Promise((resolve) => {
        this.$http
          .post("/erp/TableFieldsSetting/tableFieldSave", param)
          .then((rs) => {
            if (String(rs.data.code) !== "200")
              return this.$message.error(rs.data.msg);
            resolve();
            return this.$message.success(rs.data.data);
          })
          .catch(() => {
            this.$message.error("请求服务器失败! 请联系技术人员");
          });
      });
    },

    // 获取
    fetchMyFields() {
      const param = { table_code: this.getTableCode() };
      return new Promise((resolve) => {
        this.$http
          .post("/erp/TableFieldsSetting/tableFieldGet", param)
          .then((rs) => {
            if (String(rs.data.code) !== "200") {
              this.$message.error(rs.data.msg);
              return;
            }
            resolve(rs.data.data);
          })
          .catch(() => {
            this.$message.error("请求服务器失败, 请联系技术人员");
          });
      });
    },

    getTableCode() {
      return String(this.page) === "1" ? "wavepicking" : "aswavepicking";
    },
  },
};
</script>

<style scoped>
._dialog_container_box {
  padding: 20px;
}
._item {
  width: 130px;
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/components/fieldSetting.vue